<header #header class="drag">
  <h3 class="drag">{{headerTitle}}</h3>
  <mat-icon class="close" (click)="changeClose()">close</mat-icon>
  <mat-icon class="arrow" *ngIf="show" (click)="changeShow()">expand_less</mat-icon>
  <mat-icon class="arrow" *ngIf="!show" (click)="changeShow()">expand_more</mat-icon>
  <img *ngIf="settings" width="18" height="18" src="/assets/images/window_settings.png" (click)="settingsClick.emit()"
       srcset="/assets/images/window_settings.png 1x, /assets/images/window_settings_2x.png 2x">
</header>
